// Configuration for API endpoints based on environment

const normalizeApiUrl = (url) => {
  if (!url) return '';
  let cleaned = url.trim();
  // remove trailing slashes
  cleaned = cleaned.replace(/\/+$|\/$/g, '').replace(/\/+$/g, '');
  // if it ends with /api, strip it so we can append /api/... once
  cleaned = cleaned.replace(/\/api$/i, '');
  return cleaned;
};

const getApiBaseUrl = () => {
  const mode = import.meta.env.MODE;
  const rawApiUrl = import.meta.env.VITE_API_URL;
  const apiUrl = normalizeApiUrl(rawApiUrl);

  if (mode === 'production') {
    if (apiUrl) return apiUrl; // explicit production API (without trailing /api)
    if (typeof window !== 'undefined') {
      // default: same origin
      return normalizeApiUrl(window.location.origin);
    }
    return '';
  }

  // Development: prefer provided API URL, otherwise localhost
  return apiUrl || 'http://localhost:3001';
};

export const API_BASE_URL = getApiBaseUrl();

export const API_ENDPOINTS = {
  analyzeAdmission: `${API_BASE_URL}/api/analyze-admission-chances`,
  getUserAnalyses: (userId) => `${API_BASE_URL}/api/user-analyses/${userId}`,
  getAnalysis: (analysisId) => `${API_BASE_URL}/api/analyses/${analysisId}`,
  deleteAnalysis: (analysisId) => `${API_BASE_URL}/api/analyses/${analysisId}`,
  generateRecommendations: `${API_BASE_URL}/api/generate-recommendations`,
};

export default {
  API_BASE_URL,
  API_ENDPOINTS,
};
